import * as React from "react";
const Component = props => <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" viewBox="0 0 1000 1000" {...props}><rect width="100%" height="100%" fill="transparent" /><path d="M4091 7577h249c-5 170-2 329-6 499-3 70-46 119-115 127-74 0-121-49-125-129zm187 341-6 33-3 9-3 9-4 9-4 8-4 8-4 6-3 5-4 4-4 3-5 4-8 4-8 5-5 3-5 2-4 2-4 3-10 5-8 4-6 3-4 3-10 4-8 3-6 2-5 1-4-1v-1l1-3 2-3 4-3 4-4 4-5 6-5 7-6 32-30 4-4 4-4 5-5 4-5 5-5 5-6 4-7 5-7 3-4 2-3 1-4 2-4 1-3 2-4v-3l1-4-1-2 1-3-24 6h-4l-4 1-5-1h-3l-4-1-3-1-4-1-3-2-4-2-2-2-3-2-1-3-2-2-1-3-1-3v-15l1-4 1-6 2-8 3-11 3-12 3-8 2-8 3-7 3-7 3-3 2-4 2-3 3-3 2-2 3-2 3-1 2-1h14l5 1 4 1 5 2 4 2 4 3 4 3 4 3 3 4 3 4 3 4 2 4 1 5 2 5 1 5 1 5v15l1 5v22l-1 5v10l-1 5z" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "evenodd",
    opacity: 1
  }} transform="translate(-182.58 -465.518)scale(.1651)" /><path d="M-363.5-48.5h739l6 2 5 1 6 2 5 3 4 3 5 3 4 3 3 4 3 4 3 4 2 5 2 4v5l1 5-1 5v5l-2 5-2 4-3 4-3 4-3 4-4 4-5 3-4 3-5 2-6 2-5 2-6 1-6 1h-739l-6-1-6-1-5-2-6-2-5-2-4-3-5-3-4-4-3-4-3-4-3-4-2-4-1-5-1-5-1-5 1-5 1-5 1-4 2-5 3-4 3-4 3-4 4-3 5-3 4-3 5-3 6-2 5-1 6-2h6z" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "evenodd",
    opacity: 1
  }} transform="translate(505.404 243.242)scale(.1651)" /><path d="M-437.5-47h882l7 1 7 1 7 2 6 2 6 2 6 3 5 3 5 3 4 4 4 4 3 4 2 4 2 5 1 2v2l1 3v4l-1 3v2l-1 2-2 5-2 4-3 4-4 4-4 4-5 3-5 3-6 3-6 2-6 2-7 2-7 1-7 1h-890l-7-1-7-1-6-2-7-2-6-2-5-3-6-3-4-3-5-4-4-4-3-4-2-4-2-5V7l-1-2V-5l1-2v-2l2-5 2-4 3-4 4-4 5-4 4-3 6-3 5-3 6-2 7-2 6-2 7-1 7-1z" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "evenodd",
    opacity: 1
  }} transform="translate(503.927 216.427)scale(.1651)" /><path d="M-513.5-50.5h1027l9 1h9l8 2 8 2 7 2 7 2 7 3 6 3 6 4 5 4 4 4 4 4 1 3 2 2 1 2 1 3 1 2v16l-1 2-1 3-1 2-2 2-1 2-4 5-4 4-5 4-6 3-6 4-7 3-7 2-7 2-8 2-8 1-9 1h-1045l-8-1-9-1-7-2-8-2-7-2-6-3-7-4-5-3-5-4-4-4-4-5-2-2-1-2-1-2-1-3-1-2-1-3v-10l1-3 1-2 1-3 1-2 1-2 2-3 4-4 4-4 5-4 5-4 7-3 6-3 7-2 8-2 7-2 9-2h8z" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "evenodd",
    opacity: 1
  }} transform="translate(504.596 190.933)scale(.1651)" /><path d="M3642 3878h1007c-112-274 435-552 169-728 17 142-70 214-167 289l-13 9c128-219 133-468-111-602 59 75 84 180 40 279-89 156-296 250-435 350-14-218-93-379-318-452 86 101 94 183 25 304-100 159-295 292-239 523 8 16 16 28 42 28" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "evenodd",
    opacity: 1
  }} transform="translate(-182.53 -465.04)scale(.1651)" /><path d="M3378 6608c-73 100-130 145-187 353-60 284 57 400 298 217 105-110 152-147 251-375 104 37 140 55 259 54-11 124-11 209 3 332 87 387 318 421 414 22 27-107 23-232 14-352 82 0 153-14 229-46 70 193 104 209 230 343 265 206 374 52 325-216-40-147-67-175-212-346 83-61 151-126 219-204 157 112 216 130 356 171 261 57 391-70 219-277-144-144-191-180-375-260 18-73 29-171 24-264 192 6 288 13 454-25 205-65 315-266-1-358-174-28-249-28-447-13-13-103-30-172-57-267 133-68 228-112 345-235 175-179 77-405-224-306-183 77-162 68-355 189-47-48-98-92-152-122 46-131 145-283 180-438 47-199-66-397-311-166-226 208-289 476-349 671 380 140 637 535 617 965-40 511-482 897-984 904-534-12-918-460-956-943-9-395 248-759 604-921-111-342-174-465-324-631-297-272-391-12-343 197 27 113 54 179 184 357-83 64-99 99-167 179-136-90-225-149-353-191-178-41-411 13-268 253 48 86 202 216 408 303-11 73-22 140-19 243-156 3-198-4-379 9-204 10-420 215-145 366 219 83 327 69 525 64 2 89 19 152 49 237-135 63-192 67-325 199-228 273-75 442 252 328 98-42 182-93 288-178 64 80 104 114 186 178" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "evenodd",
    opacity: 1
  }} transform="translate(-182.397 -465.148)scale(.1651)" /><path d="M95-54v10l-1 10-1 9-1 10-2 9-2 9-3 9-3 9-7 18-8 18-8 19-11 19-4 7-4 7-6 7-6 6-5 4-6 5-6 4-8 5-10 5-12 5-16 6-18 8-31 11h-9l-1-1v-1l-1-2v-4l1-2 3-3 5-6 7-7 10-9 37-32 10-8 9-8 10-9 9-10 5-6 5-5 4-5 3-5 3-4 2-3 1-3V32l-1-4-1-4-3-8-4-8-2-3-3-5-4-6-6-7-6-8-7-8-7-6-7-6-6-5-5-4-1-2-1-1-1-1v-1l20-47 26-59 2-3 3-3 2-3 3-3v-1l1-1 7 7 7 6 5 4 5 5 12 11 10 11 4 4 3 5 3 4 2 4 4 7 3 6 3 8 2 7 2 8 1 8v8z" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "evenodd",
    opacity: 1
  }} transform="translate(926.567 837.715)scale(.1651)" /><path d="m23.5-149.5-28 68-10 29v34l-1 7v33l-1 8-1 9-1 10-1 10-1 10-2 10-1 7-1 8-3 10-2 11-3 12-3 12-3 12-3 12 4 6h2l2-1 1-1h2l3-3 3-4 4-5 5-7 6-9 7-11 21-45 4-10 3-10 4-9 2-9 2-10 1-10 1-12 1-13 3-80v-51l2-30v-3l-2-2-2-2-4 3-1 2-3 5-2 3-2 4z" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "evenodd",
    opacity: 1
  }} transform="translate(890.836 841.427)scale(.1651)" /><path d="m58-14.5 1 6v6l-1 6-2 7-2 7-3 8-3 8-5 8-4 9-6 8-7 7-7 8-5 4-4 3-4 2H1l-3-2-5-4-6-4-6-6-6-4-5-5-5-4-5-3-5-4-3-4-4-4-3-3-3-3-1-3v-3l3-7 3-6 2-6 2-5 5-11 5-11 5-9 3-7 5-9 6-8 5-10 6-9 3-5 4-6 3 3 3 3 5 3 5 3 12 10 9 8 7 7 6 6 3 5 3 6 2 7z" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "evenodd",
    opacity: 1
  }} transform="translate(873.594 753.136)scale(.1651)" /><path d="m58-14.5-1-7-2-7-4-6-3-6-6-6-7-6-9-9-11-9-6-4-4-2-4-3-3-3-4 6-3 4-6 10-5 9-5 9-6 9-3 7-4 9-5 10-6 12-2 5-2 5-3 7-3 7v3l1 3 3 3 3 3 4 4 4 4 4 3 5 4 5 5 6 4 6 5 6 5 5 4 5 4 3 1 3 1h3l4-2 4-3 4-4 8-8 6-8 6-8 4-8 5-8 3-8 3-8 3-7 1-7 1-6v-6z" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "evenodd",
    opacity: 1
  }} transform="translate(802.473 752.311)scale(.1651)" /><path d="m58-15-1-7-2-6-4-7-3-5-6-6-7-7-9-8-12-10-5-3-4-3-4-3-3-3-5 6-3 5-5 9-5 10-6 9-5 9-3 7-4 8-5 11-6 12-2 4-2 6-3 6-3 8v2l1 3 3 3 3 4 4 3 4 4 4 4 5 3 5 4 5 5 6 5 6 5 6 5 5 3 3 2 3 1 3-1 4-2 4-3 4-4 7-7 7-8 5-8 5-8 5-9 3-8 3-7 3-8 1-6 1-6v-7z" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "evenodd",
    opacity: 1
  }} transform="translate(812.704 776.651)scale(.1651)" /><path d="m58.5-15-2-7-2-6-3-6-4-6-5-6-7-7-10-8-11-10-6-3-4-3-3-2-4-4-4 7-3 4-5 10-6 9-5 9-5 9-4 7-4 8-5 11-5 12-2 4-3 6-2 6-4 8 1 2 1 3 2 3 3 4 4 3 4 4 5 3 4 4 6 4 5 5 6 5 6 5 6 5 4 3 4 2 2 1h2l1-1 2-1 2-1 4-3 5-4 7-7 7-8 5-8 5-8 4-9 4-8 3-7 2-7 2-7v-7l1-6z" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "evenodd",
    opacity: 1
  }} transform="translate(792.49 777.806)scale(.1651)" /><path d="m70-92-9 12-10 13-11 15-14 16-13 14L-1-5l-18 19-21 22-6 8-5 7-5 7-3 6-3 6-3 7-3 7-3 8 12-12 13-13 13-12 13-13 14-15L7 12 18-2l11-12 9-11 8-11 7-10 5-8 3-6 2-4 2-5 1-4 3-8 2-6v-5z" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "evenodd",
    opacity: 1
  }} transform="translate(726.238 778.302)scale(.1651)" /><path d="m5280 7894 1-2 1-1 6-7 11-12 16-17 21-23 10-11 11-12 10-13 12-13 11-14 12-14 12-14 13-15 21-26 20-24 20-24 18-23 17-22 17-21 15-20 14-19 14-18 13-18 12-17 11-16 10-16 10-15 10-14 8-14 3-7 3-4 1-2 1-1 1-2h1l1 2 1 2 1 2v2l-1 7-1 8-2 6-1 7-2 13-4 12-5 12-5 13-6 12-5 13-7 13-8 13-8 15-11 17-14 20-16 22-10 13-10 13-11 14-11 14-11 15-12 14-12 15-13 15-134 161h49l10 1h10l9 1 10 1 11 1 12 2 13 1 13 2 14 2 15 2 16 2 24 3 22 3 21 2 20 2 18 2 17 1 14 1 14 1 12 1 12 1h54l10-1 63-1 31-2 30-3 30-3 29-4 28-4 28-5 27-6 26-6 15-4 16-4 15-5 16-5 15-5 16-6 16-6 16-6 16-7 16-6 17-7 16-8 33-16 34-17 15-8 15-8 15-9 15-9 15-9 14-9 15-10 14-10 14-10 15-11 14-11 15-11 15-13 15-13 16-12 15-14 12-11 11-11 9-10 9-9 7-8 6-8 5-6 4-6 1-3 1-2 1-4 1-4 1-8 1-10v-9l1-9 1-3 1-3 1-3 1-2 8-17 9-16 8-17 8-17 5-8 6-11 7-11 8-14 2-1 2-1v4l-1 9-1 13-2 18-1 9-1 10-2 10-1 9-2 10-2 9-2 10-2 9-3 12-3 12-3 11-3 10-4 9-3 9-4 8-3 8-7 10-6 11-7 11-7 10-8 11-8 11-9 10-8 11-10 11-9 11-11 11-10 11-11 10-11 11-12 11-12 11-25 22-25 21-26 19-26 19-27 19-28 17-27 17-28 15-31 16-30 16-31 14-31 12-31 13-32 11-31 11-32 9-32 9-33 7-33 7-32 6-34 5-33 4-34 3-34 2v1l-27 1-24 1h-44l-19-1-18-2-16-1-15-3-8-2-9-2-8-2-9-3-8-3-8-4-8-3-9-4-8-4-8-4-8-5-8-5-8-5-8-6-8-5-7-7-2 1-1 2-2 4-2 5-4 14-6 19-3 13-4 13-4 14-5 14-4 12-6 11-5 11-6 11-6 10-7 9-7 9-7 8-9 10-9 8-5 4-4 3-5 3-5 3-4 2-5 3-5 2-5 1-4 1-5 1-5 1-5 1-5-1h-9l-5-1-4-1-4-1-5-1-3-3-4-2-4-2-4-3-3-3-4-3-4-3-3-4-3-5-3-4-3-4-3-5-2-5-5-11-4-11-3-12-3-14-1-13-2-15v-18l-1-4 1-4-1-15v-44l1-10v-10l1-11v-12l1-13v-13l1-14 1-15 4-91 10-116 42-124 2-2 2-1 1 1v44l-1 13-1 16-1 17-2 19-1 11v12l-1 13-1 14-1 16-1 16-2 18-1 19-2 18-1 16-1 14-1 11-1 9-1 7v15l-1 8v17m154 95v-3l-1-2v-3l-1-2-1-2-2-3-2-2-2-1-5-4-6-4-7-3-8-2-8-2-9-2-7-1-8-1-7-2h-21l-6 1-5 1h-5l-4 2-4 2-4 2-4 2-2 3-3 3-3 4-1 3-2 4v4l-1 5v18l1 7 1 6 2 6 1 5 2 5 2 4 3 4 4 4 5 4 6 4 6 3 6 1 8 2h17l10-1 10-2 9-2 7-3 8-3 6-5 3-2 3-3 2-3 3-3 4-4 3-6 2-5 3-5 1-5 1-6 1-6z" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "evenodd",
    opacity: 1
  }} transform="translate(-182.696 -465.498)scale(.1651)" /><path d="m5082 7981-1 13-2 13-2 15-4 15-4 15-5 14-6 14-6 13-5 10-6 9-5 9-6 8-5 7-6 7-5 5-6 6-5 5-6 4-6 4-6 3-6 2-7 2-6 1h-12l-5-1-4-1-5-1-3-2-4-2-3-3-3-3-3-4-2-4-2-4-1-4-1-5-1-6-1-6v-6l1-9 1-10 2-9 2-10 19-41 18-31-5-2-4-1h-3v-4l2-5 2-7 4-9 5-14 6-13 5-10 4-8 21-49 2-3 1-3 2-3 1-2 2-1 2-2h6l4 1 5 3 6 3 6 3 5 4 5 3 4 3 9 8 7 9 3 4 3 4 3 5 2 4 2 4 1 5 2 6 1 5v7l1 7v8zm-56 92-1-4v-4l-1-4-1-4-2-3-2-3-3-3-2-2-4-3-4-4-4-3-5-3-5-3-5-2-4-1-4-1-1 1-2 1-1 1-3 2-5 7-6 8-3 5-2 4-2 5-2 4-2 4-1 4v14l1 3 1 3 1 2 1 2 2 2 1 1 2 2 2 1 3 1 3 1 6 1 7 1h4l4-1 3-1 4-1 4-1 4-2 4-2 3-2 4-2 4-3 2-3 3-3 1-3 2-3v-3z" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "evenodd",
    opacity: 1
  }} transform="translate(-182.664 -465.549)scale(.1651)" /><path d="m-81.5-200 61-105h1l37-67 2-6 3-7 2-8 2-7 1-8 1-8 1-10 1-9v-10l2-44v-6l1-11 1-16 3-19 2-21 2-16 2-14 2-10 2-9 3-10 3-10 4-12 4-13 6-14 7-15 7-18 2-2 1-1 1-1h2l1 1v14l-1 13-2 17-3 21-3 21-3 17-1 12-1 9-2 49v13l1 9v9l1 7 2 8 1 7 2 6 2 6 1 3 3 4 2 3 2 3 3 2 3 3 3 1 4 2 4 2 4 1 3 1 5 1h15l4-10 3-10 3-10 3-10 2-3 3-9 5-13 7-19 3-7 4-6 3-7 3-6 4-6 3-6 4-5 4-5 5-7 6-5 7-5 6-4 7-3 6-2 7-2h13l6 1 5 2 5 2 2 2 2 1 2 2 2 2 1 2 1 3 1 2 1 3v8l-1 3-1 2-1 2-1 2-2 2-3 3-2 3-3 1h-6l-8-3-5-2-6-1h-5l-4-1-6 1-4 1-5 1-5 3-5 3-4 3-4 5-4 5-4 5-4 5-2 4-3 5-1 4-2 5v4l-1 4v3l1 3 1 3 1 3 2 4 1 3 3 3 2 3 3 3 3 3 3 2 4 2 3 1 4 1 4 1h10l3-1 3-1 3-2 3-1 3-2 2-2 6-6 6-6 6-8 6-9 3-5 3-7 4-7 5-8 2-5 2-4 2-2 2-3 2-2 2-1h3l1 1 1 1 1 2v3l-1 2v3l-1 4-1 4-4 10-4 11-5 12-6 15-5 10-4 9-5 10-5 10-5 9-5 9-6 8-5 9-7 10-7 9-6 8-7 8-7 7-8 6-7 7-7 5-7 5-8 3-8 4-8 3-8 2-7 1-8 1-9 1-5-1h-6l-5-1h-5l-4-2-5-2-4-2-5-2-3-3-4-2-4-3-3-4-4-3-3-5-3-4-3-4-1-4-2-3-40 73 7 3 5 2 4 2 3 2 4 2 5 4 8 4 9 6 5 3 5 4 3 4 3 3 3 5 1 4 1 5 1 5-1 3v3l-1 3-1 4-7 14-6 14-4 6-3 7-4 5-3 6-3 5-4 5-4 4-4 4-4 4-4 4-4 3-4 3-4 2-5 3-7 2-8 3-9 3-11 3-12 4-13 3-15 4-13 5-13 6-12 5-11 7-11 7-12 7-11 9-10 9-9 8-8 8-7 8-6 9-6 8-4 7-3 8-4 10-3 10-3 10-3 11-3 12-3 11-3 12-2 13-1 6-2 11-3 15-2 20-1 6-1 8-1 12-1 15-2 18-2 21-2 24-2 27-3 27-2 25-2 21-1 19-1 16-1 12v10l-1 7-6 159v9l-1 10v10l-1 11v12l-1 12-1 12-1 13-2 24-3 16-1 6-1 4-1 2v1l-1 1h-1v-11l-1-11-1-8-1-9v-12l-1-12-1-10-1-11v-23l-1-6V467l1-12v-95l1-24 1-24 1-24 2-24 2-24 2-24 3-24 3-24 4-23 4-22 4-21 4-20 4-19 5-18 5-17 3-12 4-12 4-12 5-12 4-11 6-11 5-10 6-11 5-10 6-10 7-9 6-10 7-9 6-8 9-9 8-10 9-9 8-8 8-7 7-6z" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "evenodd",
    opacity: 1
  }} transform="translate(591.527 878.527)scale(.1651)" /><path d="M23-169-4-92l-9 33v7l-1 7v33l-1 9v27l-1 10-1 11-1 11-1 11-1 11-2 12-1 8-1 9-2 11-2 13-3 13-3 14-3 13-3 14 4 7h3l1-1 2-1 3-3 3-4 4-6 5-8 5-11 6-12 21-52 4-11 3-11 3-11 2-10 2-11 1-12 2-13V0l3-92 1-57 2-35v-1l-1-2-1-3-2-2-3 4-2 3-3 5-2 4-2 4z" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "evenodd",
    opacity: 1
  }} transform="translate(166.84 805.375)scale(.1651)" /><path d="m177.5-164.5 1-5 1-4v-8l-1-2-1-1-1-1h-2l-1 1-2 2-2 2-4 7-6 10-7 10-5 8-5 7-4 4-5 4-7 4-8 4-9 5-13 7-10 5-7 4-4 2-6 4-5 4-6 4-4 4-5 4-4 4-4 4-3 4-3 5-4 5-4 7-4 8-9 19-11 23-10 22-8 17-5 11-4 6-7 8-10 10-13 11-15 12-3 2-5 3-8 6-11 7-17 11-12 8-8 5-4 2-9 7-8 6-7 5-7 5-5 5-4 4-1 1-1 2-1 1v2l2 1 2 2 1 2h3l2 1h3l3 1 3-1h9l10-1 13-2 16-3 14-3 13-3 11-3 8-3 4-2 4-2 5-3 4-3 4-2 4-3 3-3 4-4 3-4 3-3 3-4 4-4 5-9 5-9 3-6 3-7 3-8 4-8 3-10 5-10 4-12 5-12 6-13 5-10 6-9 5-8 2-3 3-4 5-3 4-4 5-3 4-3 4-2 3-1 43-22 5-3 4-3 4-4 5-4 4-5 4-6 4-6 4-7 4-8 4-8 4-9 4-10 3-10 4-11 4-12z" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "evenodd",
    opacity: 1
  }} transform="translate(174.362 861.23)scale(.1651)" /><path d="m55-14 1 6-1 6v6l-2 6-2 7-3 7-3 7-4 8-4 8-6 8-6 7-7 7-4 4-4 3-2 1H7l-2 1H4l-3-1-3-2-4-3-6-4-5-5-6-4-5-5-5-3-5-4-4-3-4-4-3-3-3-3-2-4-1-2-1-3 3-6 3-7 2-5 2-4 6-12 4-9 4-8 3-7 5-8 5-9 5-9 5-8 3-4 4-7 3 3 4 3 3 3 6 3 10 9 9 8 7 6 5 6 3 5 4 6 2 6z" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "evenodd",
    opacity: 1
  }} transform="translate(301.492 811.468)scale(.1651)" /><path d="M55.5-13.5v18l-2 6-2 7-3 7-3 7-4 8-5 8-5 8-6 7-7 7-4 4-4 2-2 2h-7l-3-2-5-3-5-4-6-5-5-5-5-4-5-4-5-3-4-4-4-3-3-4-3-3-2-3-2-3v-2l3-7 3-6 2-5 2-4 5-12 5-10 4-8 3-6 5-9 5-8 5-9 5-9 3-4 4-6 3 3 3 3 4 2 5 3 11 9 9 8 7 7 5 5 3 6 3 5 2 7z" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "evenodd",
    opacity: 1
  }} transform="translate(282.433 812.54)scale(.1651)" /><path d="m59.5-14-1-3-1-3v-3l-1-3-2-3-1-3-2-2-2-3-6-6-7-6-9-8-11-9-5-3-5-3-7-3-7-3-3 6-3 4-5 7-5 9-5 9-6 10-26 58v2l1 2 1 2 1 1 3 4 4 3 5 3 6 3 5 4 5 3 2 1 6 4 8 6 11 9 4 2 2 2 3 1 1 1 3-1 4-3 4-3 5-4 5-6 6-7 6-8 6-9 4-4 2-5 2-5 3-5 1-5 1-5 1-5V-9z" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "evenodd",
    opacity: 1
  }} transform="translate(101.414 837.705)scale(.1651)" /><path d="m224-49-3 11-2 10-2 8-2 8-2 7-1 6-3 8-2 7-4 11-4 10-4 10-4 10-5 10-5 10-5 10-6 10-6 11-6 10-7 10-6 10-7 9-7 9-7 10-8 9-12 13-12 13-12 11-13 11-12 10-13 9-13 8-13 8-7 3-6 3-7 3-7 3-7 2-7 3-7 2-8 2-7 1-7 2-8 1-8 1-7 1h-16l-8 1-10-1h-8l-9-1-8-1-8-2-8-2-7-2-8-2-7-4-6-3-7-3-6-4-6-5-5-4-6-6-5-5-4-5-5-6-4-6-4-7-4-6-3-7-3-7-2-7-3-7-1-8-2-7-2-8-1-8-1-9v-35l1-9 1-10 2-10 1-9 2-10 2-10 3-10 2-10 3-9 2-9 3-8 2-8 3-7 3-7 6-14 6-14 7-14 7-14 5-10 5-10 6-10 5-10 6-10 6-9 5-10 6-10 4-7 3-6 3-3 1-2h1l1-1h2l3 1v1l1 2-1 4v5l-1 5-1 6-1 4-1 5-39 82-7 17-5 14-5 12-3 8-2 6-1 7-2 6-1 6-1 7v6l-1 7v15l1 7v8l2 7 2 8 1 6 3 7 3 6 3 6 3 5 4 6 4 5 5 5 5 4 5 4 6 4 4 3 5 2 5 3 5 2 10 4 11 3 11 3 12 1 13 1 13 1 19-1 17-1 9-1 8-1 8-1 7-1 8-2 7-2 8-3 8-3 8-3 7-3 8-4 8-4 9-5 8-5 7-5 8-6 7-5 7-6 7-7 6-6 9-11 10-12 11-14 12-16 6-11 6-11 5-10 4-10 1-6 2-5 1-6 1-6 1-6v-7l1-7v-7l2-82v-10l1-10 2-9 2-9 2-9 4-10 4-11 5-13 23-45 4-5 2-5 2-3 1-2 3-3 4-5 1 1 1 2 1 2 1 1 1 4-1 4-5 40-6 57-1 16v15l-2 14-2 13v7l-2 7-1 8-2 8-2 8-2 10-2 9z" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "evenodd",
    opacity: 1
  }} transform="translate(99.701 850.928)scale(.1651)" /><path d="m3242 8049-38-10-7 8-7 6-5 6-5 4-7 8-9 7-10 8-11 7-11 7-11 6-11 7-13 6-12 5-13 5-14 5-13 5-11 3-12 3-12 4-12 3-14 3-14 3-14 3-15 3-16 3-17 3-18 3-18 2-18 3-19 3-20 2-21 2-21 2-21 2-20 1-20 2h-20l-20 1-20 1h-67l-12-1-13-1h-11l-11-1-12-1-10-1-15-2-14-3-13-3-12-3-11-4-10-4-8-4-9-5-3-2-3-3-4-4-3-3-2-4-3-4-2-5-1-4-2-10-2-11-1-11-1-12v-14l1-7v-8l1-7 1-8v-8l1-8 2-8 1-6 1-6 1-5 2-3 2-3h1l1-1 1-1h3l2 1 1 1 1 2 2 2 1 2 1 3v4l2 7 2 7 3 7 3 7 3 5 4 5 5 4 5 4 6 4 6 3 7 3 8 2 8 2 8 2 9 2 9 2 10 2 10 1 11 1 11 2 12 1 11 1 10 1h12l10 1 11 1h78l19-1h18l18-1h19l19-1 18-1 19-1 20-2 21-2 21-2 23-3 24-3 25-3 26-4 12-2 12-1 10-2 11-2 8-1 8-2 7-1 7-1 11-2 11-2 11-3 9-2 9-3 9-2 7-2 8-3 6-3 6-2 6-2 4-1 9-4 8-3 9-5 9-4 6-4 7-5 7-6 6-5h1l1 1 1 1v1l1 3 1 4-1 4-1 6h8l4-1h6l1 1v1-2l9-1 8-1 5-1 4-1 7-3 6-2 6-2 4-1 11-5 10-4 10-4 8-5 6-3 5-3 4-3 3-3 3-4 1-2 2-3v-3l-2-12-2-4-3-2-2-3-4-2-3-2h-4l-4-1-5-1-16 2-2 1h-2l-3-1h-1l-1-2-1-2v-4l2-3 2-3 3-3 2-4 4-4 5-3 5-4 5-4 7-5 8-4 8-4 8-3 8-3 8-1 8-1 9-1 6 1h13l5 1 6 1 6 1 5 1 5 2 5 2 3 2 4 2 3 3 2 3 1 3 1 4 1 4v3l-1 4-1 3-1 3-1 3-1 3-2 3-2 4-4 5-2 4-2 3v2l-1 1v1l1 1h1l1 2h8l4-1 4-1 5-2 5-2 5-2 6-2v-1l5-3 5-3 5-3 5-4 4-4 5-3 3-3 3-2 5-5v-1l6-6 7-6 6-6 7-5 5-3 5-4 5-2 4-2 4-2 4-1 3-1h8l5 1 6 2 6 3 6 3 5 2 3 1 3 1h2l2-1 2-2 4-3 8-8 10-12 7-9 6-8 6-7 5-5 4-3 4-3 3-3 4-2 3-2 4-1 3-1h7l5 1 7 2 9 2 9 2 9 2 6 1h8l1-1 2-2 3-3 6-7 9-11 6-7 7-8 6-7 6-8 7-7 6-8 6-8 7-7 10-8 9-8 10-8 9-8 9-5 7-5 9-4 7-4 8-2 7-2 8-1h20l5 1 5 2 4 1 4 2 3 2 3 3 3 3 2 3 2 3 1 4 1 4 1 4 1 5v4l-1 9-1 7-2 8-2 8-3 8-4 9-5 10-6 10-7 11-6 11-7 9-6 9-5 7-6 6-5 5-5 6-6 5-4 4-6 4-5 4-9 5-8 6-9 5-7 4-9 4-7 4-7 2-7 3-8 2-7 2-7 2-7 1-7 1-8 1-7 1h-19l-11-1-9-1-8-2-7-2-7-3-7-3-7-4-7-4-5-3-3-3-3-2-4-3-3-5-3 4-2 2-7 8-6 6-5 5-3 3-5 6-5 5-5 4-4 4-5 4-4 3-5 2-4 2-4 2-5 1-3 1h-5l-5-1-9-3-6-2-5-2-5-1h-8l-3 1-4 1-4 2-4 2-4 2-5 3-5 3-41 32h-1v1l-7 5-8 5-4 2-3 2-4 1-3 1-7 2-9 2h-10l-11 1-3-1h-5l-5-1-5-1-6-2-4-1h-9l-4 1-5 2-6 4-13 9-11 8-10 6-7 5-6 5-6 4-5 4-5 4-5 2-4 3-4 2-5 2-4 1-4 1h-4l-3 1-23-6v-3 1zm691-293v-1l-1-1-1-1-2-1-4-2-7-2-7-3-7-2-6-1h-15l-5 1-5 1-5 2-4 2-5 1-5 3-4 3-4 3-5 3-5 3-10 9-9 9-4 4-4 4-3 3-4 4-5 6-5 5-3 6-3 5h7l7-1 5-1h5l14-2 14-3 13-4 13-4 12-5 11-5 11-6 10-6 6-3 5-4 5-3 3-4 3-3 2-3 1-3z" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "evenodd",
    opacity: 1
  }} transform="translate(-182.41 -465.528)scale(.1651)" /><path d="M4043 6470h293l46-1920 68-96 31-44h-617l88 140zm53-1920c41-43 105-49 140 1l-1 1291h-91z" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "evenodd",
    opacity: 1
  }} transform="translate(-182.557 -465.198)scale(.1651)" /><path d="M23-169-4-92l-9 32v15l-1 8v24l-1 9 1 9-1 10v9l-1 10-1 11-1 10-1 11-1 12-2 11-1 9-1 9-2 11-2 13-3 13-3 14-3 13-3 14 4 7h2l1-1 2-1 1-1 3-3 4-4 3-5 5-9 5-10 6-13 21-51 4-11 3-11 3-11 2-10 2-11 1-12 2-14V0l3-92 1-57 2-35v-2l-1-2-1-2-2-2-3 4-2 3-3 4-2 5-2 3z" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "evenodd",
    opacity: 1
  }} transform="translate(224.924 798.114)scale(.1651)" /><path d="m55-14 1 5v7l-1 6-2 6-2 6-2 8-4 7-4 8-4 8-6 8-6 7-7 7-4 4-4 2-2 1-1 1-2 1H4l-2-1-4-2-4-3-6-5-5-4-6-5-5-4-5-4-5-3-4-4-3-3-4-4-3-3-2-3-1-3-1-2 4-7 2-6 2-5 3-4 5-12 4-10 4-8 3-6 5-8 5-9 5-9 5-9 3-4 4-6 4 3 3 3 4 2 5 3 10 9 9 8 7 7 5 5 4 6 3 5 2 7z" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "evenodd",
    opacity: 1
  }} transform="translate(199.844 920.707)scale(.1651)" /><path d="M55.5-13.5v17l-2 6-2 8-3 7-3 7-4 8-5 8-5 7-6 7-7 7-4 4-4 3-2 1-2 1h-5l-3-2-4-3-6-5-5-4-6-5-5-4-5-4-5-4-4-3-4-4-3-3-3-3-2-3-2-3v-2l3-7 3-6 2-5 2-5 5-11 5-10 4-8 3-7 5-8 5-9 5-8 5-9 3-4 4-6 3 3 4 2 3 3 5 3 11 9 9 8 7 6 5 6 3 5 3 6 2 6z" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "evenodd",
    opacity: 1
  }} transform="translate(180.785 921.78)scale(.1651)" /><path d="m55-13.5 1 5-1 6v7l-2 6-2 6-3 7-3 8-4 8-5 8-6 8-5 7-7 7-5 4-4 2-1 1-2 1H1l-3-2-5-3-5-5-6-5-5-4-5-4-5-4-5-3-4-4-4-3-3-4-4-3-1-3-2-3v-2l3-7 3-6 2-5 2-4 5-12 5-10 4-8 3-6 5-9 5-8 5-9 5-9 3-4 4-6 3 3 3 3 4 2 5 3 11 9 9 8 7 7 5 5 3 6 3 5 2 6z" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "evenodd",
    opacity: 1
  }} transform="translate(402.645 774.588)scale(.1651)" /></svg>;
export default Component;
export { Component as ReactComponent };